export default __webpack_public_path__ + "static/media/HappySogui.1f9ce02a.jpg";